(function () {
  'use strict';

  function pickVideoUrl(v) {
    if (!v) return '';
    return v.url || v.s3_url || v.video_url || '';
  }

  function pickPosterUrl(v, videoUrl) {
    if (window.WOMVideoPoster) {
      /* Trusted API thumbnail only — do not fall back to product image */
      return window.WOMVideoPoster.resolveTrusted({ video: v }) || '';
    }
    if (!v) return '';
    return v.thumbnail || v.thumbnail_url || v.poster || '';
  }

  function fromVideoUrlFallback(url) {
    if (!url || typeof url !== 'string') return '';
    var path = url.split('?')[0].split('#')[0];
    if (!/\.(mp4|webm|mov|m4v)$/i.test(path)) return '';
    return path.replace(/\.(mp4|webm|mov|m4v)$/i, '.jpg');
  }

  function scheduleAfterPaint(fn) {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        requestAnimationFrame(fn);
      });
    } else {
      window.setTimeout(fn, 32);
    }
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parseProductMetaResponse(data) {
    if (data && data.success === true && data.metafields) return data;
    return null;
  }

  var LABEL_ORDER = ['red', 'green', 'yellow'];

  function getProductLabels(meta) {
    if (!meta || !meta.metafields) return [];
    var labels = [];
    var labelMap = meta.metafields.labels || {};
    LABEL_ORDER.forEach(function (color) {
      var text = labelMap[color];
      if (text) labels.push({ color: color, text: String(text) });
    });
    return labels;
  }

  function renderProductLabelsHtml(labels) {
    if (!labels || !labels.length) return '';
    return labels
      .map(function (item) {
        return (
          '<span class="labels is-' +
          escapeHtml(item.color) +
          '">' +
          escapeHtml(item.text) +
          '</span>'
        );
      })
      .join('');
  }

  function applyDraggableProductMeta(modalEl, meta) {
    if (!modalEl) return;
    var labels = getProductLabels(meta);
    var labelsEl = modalEl.querySelector('[data-wdv-labels]');
    if (!labelsEl) return;
    if (labels.length) {
      labelsEl.innerHTML = renderProductLabelsHtml(labels);
      labelsEl.hidden = false;
    } else {
      labelsEl.innerHTML = '';
      labelsEl.hidden = true;
    }
  }

  function fetchDraggableProductMeta(handle) {
    if (!handle) return Promise.resolve(null);
    var url =
      ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') +
      'products/' +
      encodeURIComponent(handle) +
      '?view=wom-meta';
    return fetch(url, { cache: 'no-store' })
      .then(function (r) {
        return r.text().then(function (text) {
          var data = null;
          try {
            data = JSON.parse(text);
          } catch (e) {
            return null;
          }
          if (!r.ok) return null;
          return parseProductMetaResponse(data);
        });
      })
      .catch(function (err) {
        return null;
      });
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-wdv-init') === '1') return;
    root.setAttribute('data-wdv-init', '1');

    var wdvId = root.getAttribute('data-wdv-id') || '';
    var apiUrl = root.getAttribute('data-api-url') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var pip = root.querySelector('[data-wdv-pip]');
    var pipVideo = root.querySelector('[data-wdv-pip-video]');
    var pipPoster = root.querySelector('[data-wdv-pip-poster]');
    var closePip = root.querySelector('[data-wdv-close]');
    var modal = document.getElementById(wdvId + '-modal');
    var modalVideo = modal ? modal.querySelector('[data-wdv-modal-video]') : null;
    var modalPoster = modal ? modal.querySelector('[data-wdv-modal-poster]') : null;
    var modalMedia = modal ? modal.querySelector('.wdv-modal__media') : null;
    var modalCloseEls = modal ? modal.querySelectorAll('[data-wdv-modal-close]') : [];
    var modalRatingEl = modal ? modal.querySelector('[data-wom-video-rating]') : null;
    var atcBtn = modal ? modal.querySelector('[data-wdv-atc]') : null;
    var productImage = root.getAttribute('data-product-image') || '';

    if (!apiUrl || !productHandle || !pip || !pipVideo || !modal || !modalVideo) return;

    var storageKey = 'wdv-closed-' + productHandle;
    var videoUrl = '';
    var loadedVideoSrc = '';
    var apiPosterUrl = '';
    var capturedPosterUrl = '';
    var posterCaptureBlocked = false;
    var metaFetched = false;
    var isDragging = false;
    var didDrag = false;
    var closeClicked = false;
    var xOffset = 0;
    var yOffset = 0;
    var initialX = 0;
    var initialY = 0;
    var currentX = 0;
    var currentY = 0;
    var positionReady = false;

    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function setDefaultPosition() {
      root.style.position = 'fixed';
      root.style.transform = 'none';
      positionReady = false;
      if (isMobile()) {
        root.style.right = '0';
        if (document.body.classList.contains('template-product')) {
          root.style.bottom = 'calc(200px + env(safe-area-inset-bottom, 0px))';
        } else {
          root.style.bottom = 'calc(186px + env(safe-area-inset-bottom, 0px))';
        }
        root.style.left = 'auto';
        root.style.top = 'auto';
        root.classList.add('wdv-wrap--anchored');
        xOffset = 0;
        yOffset = 0;
      } else {
        root.classList.add('wdv-wrap--anchored');
        root.style.bottom = document.body.classList.contains('template-product')
          ? '175px'
          : '140px';
        root.style.right = '20px';
        root.style.left = 'auto';
        root.style.top = 'auto';
      }
    }

    function showPip() {
      root.classList.add('is-pip-poster-ready');
      root.hidden = false;
      root.style.display = 'block';
      root.style.visibility = 'visible';
      root.style.opacity = '1';
    }

    function hidePip() {
      root.classList.remove('is-pip-poster-ready');
      root.hidden = true;
      root.style.display = 'none';
      if (pipVideo) {
        pipVideo.pause();
        pipVideo.muted = true;
      }
      try {
        localStorage.setItem(storageKey, '1');
      } catch (e) {}
    }

    function ensurePositionReady() {
      if (positionReady) return;
      var rect = root.getBoundingClientRect();
      xOffset = rect.left;
      yOffset = rect.top;
      root.classList.remove('wdv-wrap--anchored');
      root.style.left = xOffset + 'px';
      root.style.top = yOffset + 'px';
      root.style.right = 'auto';
      root.style.bottom = 'auto';
      positionReady = true;
    }

    // Clear any previously persisted drag positions so default always wins on load
    try {
      Object.keys(localStorage).forEach(function (key) {
        if (key.indexOf('wdv-pos') === 0) localStorage.removeItem(key);
      });
    } catch (e) {}

    function setVideoSrc(videoEl, url) {
      if (!videoEl || !url) return;
      if (videoEl.getAttribute('src') === url) return;
      videoEl.pause();
      videoEl.removeAttribute('src');
      videoEl.innerHTML = '';
      var poster = getBestPosterSrc();
      if (poster) videoEl.setAttribute('poster', poster);
      else videoEl.removeAttribute('poster');
      videoEl.src = url;
      videoEl.load();
    }

    function bustUrl(url) {
      if (!url) return '';
      return url + (url.indexOf('?') !== -1 ? '&' : '?') + 't=' + Date.now();
    }

    function derivedThumbFromVideo() {
      if (!videoUrl) return '';
      if (window.WOMVideoPoster && window.WOMVideoPoster.thumbFromVideoUrl) {
        return window.WOMVideoPoster.thumbFromVideoUrl(videoUrl) || '';
      }
      return fromVideoUrlFallback(videoUrl);
    }

    function getBestPosterSrc() {
      /* API thumbnail, captured frame, then CDN …_thumb.jpg from video URL */
      return apiPosterUrl || capturedPosterUrl || derivedThumbFromVideo() || '';
    }

    function posterHostFor(imgEl) {
      if (imgEl === pipPoster) return pip;
      if (imgEl === modalPoster) return modalMedia;
      return null;
    }

    function paintPosterNow(imgEl, src) {
      if (!imgEl || !src) return false;
      var already =
        imgEl.getAttribute('src') === src &&
        imgEl.complete &&
        imgEl.naturalWidth > 0;
      if (!already) imgEl.src = src;
      imgEl.classList.add('is-loaded');
      imgEl.setAttribute('data-poster-ready', '1');
      imgEl.removeAttribute('data-poster-loading');
      return true;
    }

    function applyPosterImage(imgEl, src) {
      if (!imgEl) return;
      var next = src || getBestPosterSrc();
      if (!next && videoUrl) {
        if (window.WOMVideoPoster && window.WOMVideoPoster.paintEager) {
          window.WOMVideoPoster.paintEager(
            imgEl,
            { videoUrl: videoUrl, poster: apiPosterUrl || '' },
            posterHostFor(imgEl)
          );
          return;
        }
      }
      if (!next) return;
      // Instant paint when we already know the URL (avoids white wait flash).
      if (
        imgEl.getAttribute('src') === next &&
        imgEl.complete &&
        imgEl.naturalWidth > 0
      ) {
        paintPosterNow(imgEl, next);
        var hostReady = posterHostFor(imgEl);
        if (hostReady) hostReady.classList.add('is-has-poster');
        return;
      }
      if (window.WOMVideoPoster && window.WOMVideoPoster.paintEager) {
        window.WOMVideoPoster.paintEager(
          imgEl,
          { poster: next, videoUrl: videoUrl },
          posterHostFor(imgEl)
        );
        return;
      }
      if (window.WOMVideoPoster && window.WOMVideoPoster.loadInto) {
        window.WOMVideoPoster.loadInto(
          imgEl,
          { poster: next, videoUrl: videoUrl },
          posterHostFor(imgEl)
        );
        return;
      }
      imgEl.addEventListener('load', function onOk() {
        imgEl.removeEventListener('load', onOk);
        imgEl.classList.add('is-loaded');
        imgEl.setAttribute('data-poster-ready', '1');
      });
      imgEl.addEventListener('error', function onErr() {
        imgEl.removeEventListener('error', onErr);
        imgEl.removeAttribute('src');
        imgEl.classList.remove('is-loaded');
      });
      if (imgEl.getAttribute('src') !== next) imgEl.src = next;
    }

    function applyAllPosters(src) {
      var next = src || getBestPosterSrc();
      applyPosterImage(modalPoster, next);
      if (pipPoster && pipPoster.classList.contains('is-loaded')) {
        applyPosterImage(pipPoster, next);
      }
      if (next && pipVideo) pipVideo.setAttribute('poster', next);
      if (next && modalVideo) modalVideo.setAttribute('poster', next);
    }

    /**
     * Preload the PiP thumbnail fully before revealing the floating player.
     * Returns a promise resolving to the loaded URL, or '' if no usable still.
     */
    function mountPipPoster(loadedUrl) {
      return new Promise(function (resolve) {
        if (!pipPoster || !loadedUrl) {
          resolve('');
          return;
        }

        function finish() {
          paintPosterNow(pipPoster, loadedUrl);
          if (pip) pip.classList.add('is-has-poster');
          if (pipVideo) pipVideo.setAttribute('poster', loadedUrl);
          applyPosterImage(modalPoster, loadedUrl);
          if (modalVideo) modalVideo.setAttribute('poster', loadedUrl);
          resolve(loadedUrl);
        }

        if (
          pipPoster.getAttribute('src') === loadedUrl &&
          pipPoster.complete &&
          pipPoster.naturalWidth > 0
        ) {
          finish();
          return;
        }

        pipPoster.onload = function () {
          pipPoster.onload = null;
          pipPoster.onerror = null;
          if (pipPoster.naturalWidth > 0) finish();
          else resolve('');
        };
        pipPoster.onerror = function () {
          pipPoster.onload = null;
          pipPoster.onerror = null;
          resolve('');
        };
        pipPoster.decoding = 'async';
        pipPoster.src = loadedUrl;
      });
    }

    function loadPipPosterBeforeShow() {
      return new Promise(function (resolve) {
        var url = getBestPosterSrc();
        if (!url) {
          resolve('');
          return;
        }

        if (window.WOMVideoPoster && window.WOMVideoPoster.loadInto && pipPoster) {
          window.WOMVideoPoster.loadInto(
            pipPoster,
            { poster: apiPosterUrl || url, videoUrl: videoUrl },
            pip
          ).then(function (loaded) {
            if (!loaded) {
              resolve('');
              return;
            }
            if (pipVideo) pipVideo.setAttribute('poster', loaded);
            applyPosterImage(modalPoster, loaded);
            if (modalVideo) modalVideo.setAttribute('poster', loaded);
            resolve(loaded);
          });
          return;
        }

        var probe = new Image();
        probe.decoding = 'async';
        probe.onload = function () {
          if (!probe.naturalWidth) {
            resolve('');
            return;
          }
          mountPipPoster(url).then(resolve);
        };
        probe.onerror = function () {
          resolve('');
        };
        probe.src = url;
      });
    }

    function syncModalPosterFromPip() {
      var fromPip =
        (pipPoster && pipPoster.getAttribute('src')) ||
        getBestPosterSrc() ||
        '';
      if (!fromPip || !modalPoster) return;
      if (
        modalPoster.getAttribute('src') === fromPip &&
        modalPoster.complete &&
        modalPoster.naturalWidth > 0
      ) {
        paintPosterNow(modalPoster, fromPip);
      } else {
        modalPoster.src = fromPip;
        modalPoster.classList.add('is-loaded');
        modalPoster.setAttribute('data-poster-ready', '1');
      }
      if (modalMedia) modalMedia.classList.add('is-has-poster');
      if (modalVideo) modalVideo.setAttribute('poster', fromPip);
    }

    function showLoadingPoster() {
      syncModalPosterFromPip();
      applyAllPosters();
      modal.classList.remove('is-video-ready');
    }

    function markModalVideoReady() {
      function reveal() {
        modal.classList.add('is-video-ready');
      }
      if (modalVideo && typeof modalVideo.requestVideoFrameCallback === 'function') {
        try {
          modalVideo.requestVideoFrameCallback(function () {
            reveal();
          });
          return;
        } catch (e) {}
      }
      // Fallback: wait one frame after play so we don't flash an empty video.
      requestAnimationFrame(function () {
        requestAnimationFrame(reveal);
      });
    }

    function markPipVideoReady() {
      pip.classList.add('is-video-ready');
    }

    function labelsAlreadyRendered() {
      var labelsEl = modal.querySelector('[data-wdv-labels]');
      return !!(labelsEl && labelsEl.getAttribute('data-wdv-labels-ready') === '1');
    }

    function capturePipFrame() {
      /* Skip canvas capture when API already sent a thumbnail */
      if (!pipVideo || capturedPosterUrl || posterCaptureBlocked || apiPosterUrl) return;
      var w = pipVideo.videoWidth;
      var h = pipVideo.videoHeight;
      if (!w || !h) return;
      try {
        var canvas = document.createElement('canvas');
        var maxW = 360;
        var scale = Math.min(1, maxW / w);
        canvas.width = Math.max(1, Math.round(w * scale));
        canvas.height = Math.max(1, Math.round(h * scale));
        var ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.drawImage(pipVideo, 0, 0, canvas.width, canvas.height);
        capturedPosterUrl = canvas.toDataURL('image/jpeg', 0.72);
        applyAllPosters(capturedPosterUrl);
      } catch (e) {
        // Cross-origin video taints the canvas, so this can never succeed on
        // this CDN. Stop retrying and keep the API/product image poster.
        posterCaptureBlocked = true;
      }
    }

    function openModal() {
      if (!videoUrl) return;

      // Paint thumbnail on the same tick — never open onto blank/white media.
      syncModalPosterFromPip();
      applyPosterImage(modalPoster, getBestPosterSrc());
      modal.classList.remove('is-video-ready');
      modal.classList.add('is-open');
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');

      scheduleAfterPaint(function () {
        if (!modal.classList.contains('is-open')) return;

        document.body.setAttribute('data-wdv-modal-open', '1');
        document.body.style.overflow = 'hidden';
        try {
          pipVideo.pause();
        } catch (e) {}
        capturePipFrame();
        syncModalPosterFromPip();

        if (modalRatingEl && window.WomVideoProductRating) {
          window.WomVideoProductRating.mount(modalRatingEl, productHandle);
        }

        // Labels are rendered server-side from the same product page Liquid.
        // Only hit ?view=wom-meta when that markup is absent.
        if (!labelsAlreadyRendered() && !metaFetched) {
          metaFetched = true;
          fetchDraggableProductMeta(productHandle).then(function (meta) {
            applyDraggableProductMeta(modal, meta);
          });
        }

        setVideoSrc(modalVideo, loadedVideoSrc || videoUrl);
        modalVideo.muted = false;

        function onPlaying() {
          markModalVideoReady();
          cleanupVideoWait();
        }

        function cleanupVideoWait() {
          modalVideo.removeEventListener('playing', onPlaying);
        }

        modalVideo.addEventListener('playing', onPlaying);

        modalVideo.play().catch(function () {
          modalVideo.muted = true;
          modalVideo.play().catch(function () {
            // Keep the thumbnail up — do not reveal an empty video layer.
            cleanupVideoWait();
          });
        });
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.classList.remove('is-video-ready');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.removeAttribute('data-wdv-modal-open');
      document.body.style.overflow = '';
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.muted = true;
      }
      showLoadingPoster();
      if (pipVideo && !root.hidden) {
        pipVideo.muted = true;
        pipVideo.play().catch(function () {});
      }
    }

    function dragStart(e) {
      if (closeClicked || e.target.closest('[data-wdv-close]')) {
        closeClicked = true;
        return;
      }
      didDrag = false;
      ensurePositionReady();
      var rect = root.getBoundingClientRect();
      if (e.type === 'touchstart') {
        initialX = e.touches[0].clientX - rect.left;
        initialY = e.touches[0].clientY - rect.top;
      } else {
        initialX = e.clientX - rect.left;
        initialY = e.clientY - rect.top;
      }
      if (pip.contains(e.target)) {
        isDragging = true;
        pip.style.cursor = 'grabbing';
        // Only listen to document move while dragging — a permanent
        // non-passive touchmove freezes page scroll on phones.
        document.addEventListener('mousemove', dragMove);
        document.addEventListener('touchmove', dragMove, { passive: false });
        document.addEventListener('mouseup', dragEnd);
        document.addEventListener('touchend', dragEnd);
      }
    }

    function dragMove(e) {
      if (!isDragging) return;
      e.preventDefault();
      if (e.type === 'touchmove') {
        currentX = e.touches[0].clientX - initialX;
        currentY = e.touches[0].clientY - initialY;
      } else {
        currentX = e.clientX - initialX;
        currentY = e.clientY - initialY;
      }
      if (Math.abs(currentX - xOffset) > 4 || Math.abs(currentY - yOffset) > 4) {
        didDrag = true;
      }
      var w = root.offsetWidth || 170;
      var h = root.offsetHeight || 260;
      var maxX = Math.max(0, window.innerWidth - w);
      var maxY = Math.max(0, window.innerHeight - h);
      xOffset = Math.max(0, Math.min(currentX, maxX));
      yOffset = Math.max(0, Math.min(currentY, maxY));
      root.style.left = xOffset + 'px';
      root.style.top = yOffset + 'px';
      root.style.right = 'auto';
      root.style.bottom = 'auto';
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;
      pip.style.cursor = 'move';
      document.removeEventListener('mousemove', dragMove);
      document.removeEventListener('touchmove', dragMove);
      document.removeEventListener('mouseup', dragEnd);
      document.removeEventListener('touchend', dragEnd);
    }

    function bindAtc() {
      if (!atcBtn) return;
      function tryBind() {
        if (window.WomVideoCart && typeof window.WomVideoCart.bind === 'function') {
          window.WomVideoCart.bind(atcBtn);
          return true;
        }
        return false;
      }
      if (!tryBind()) {
        window.setTimeout(function () {
          if (!tryBind() && typeof window.cartGiftUpdate === 'function') {
            atcBtn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var variantId = atcBtn.getAttribute('data-variant-id');
              if (!variantId || atcBtn.disabled) return;
              var price = atcBtn.getAttribute('data-variant-price') || 0;
              var type = atcBtn.getAttribute('data-product-type') || '';
              window.cartGiftUpdate(variantId, price, 1, type, 'ADD_TO_CART');
            });
          }
        }, 0);
      }
    }

    if (closePip) {
      closePip.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        hidePip();
      });
      closePip.addEventListener('touchend', function (e) {
        e.preventDefault();
        e.stopPropagation();
        hidePip();
      });
    }

    pip.addEventListener('mousedown', dragStart);
    pip.addEventListener('touchstart', dragStart, { passive: true });
    // Document move/end listeners are added only while dragging (see dragStart).

    pip.addEventListener('click', function (e) {
      if (closeClicked || e.target.closest('[data-wdv-close]')) {
        closeClicked = false;
        return;
      }
      if (didDrag) {
        didDrag = false;
        return;
      }
      openModal();
    });

    modalCloseEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    bindAtc();

    setDefaultPosition();

    try {
      if (localStorage.getItem(storageKey) === '1') return;
    } catch (e) {}

    function flattenProductVideos(productVideos) {
      var out = [];
      if (!productVideos || typeof productVideos !== 'object' || Array.isArray(productVideos)) return out;
      Object.keys(productVideos).forEach(function (handle) {
        var arr = productVideos[handle];
        if (!Array.isArray(arr)) return;
        arr.forEach(function (v) {
          if (!v) return;
          out.push(v);
        });
      });
      return out;
    }

    function pickVideoList(data) {
      if (!data) return [];
      if (Array.isArray(data.videos) && data.videos.length) return data.videos;
      if (Array.isArray(data.company_videos) && data.company_videos.length) return data.company_videos;
      if (Array.isArray(data.stories) && data.stories.length) return data.stories;
      var fromProducts = flattenProductVideos(data.product_videos);
      if (fromProducts.length) return fromProducts;
      return [];
    }

    var PERF = window.WOMPerf || { mark: function () {}, span: function () { return function () {}; } };
    var feedPromise =
      window.WOMVideoFeed && typeof window.WOMVideoFeed.get === 'function'
        ? window.WOMVideoFeed.get(apiUrl)
        : fetch(apiUrl + (apiUrl.indexOf('?') === -1 ? '?' : '&') + '_ts=' + Date.now(), {
            headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
            cache: 'no-store'
          }).then(function (r) {
            return r.ok ? r.json() : null;
          });

    feedPromise
      .then(function (data) {
        var list = pickVideoList(data);
        if (!list.length) {
          return;
        }
        videoUrl = pickVideoUrl(list[0]);
        if (!videoUrl) return;
        apiPosterUrl = pickPosterUrl(list[0], videoUrl);
        loadedVideoSrc = bustUrl(videoUrl);

        pip.classList.remove('is-video-ready');

        loadPipPosterBeforeShow().then(function (posterUrl) {
          if (!posterUrl) {
            return;
          }

          showPip();
          if (!positionReady) setDefaultPosition();

          setVideoSrc(pipVideo, loadedVideoSrc);
          pipVideo.muted = true;
          pipVideo.addEventListener('error', function () {
            var err = pipVideo.error;
          });

          function revealPip() {
            if (pipVideo.readyState < 2) return;
            capturePipFrame();
            markPipVideoReady();
            pipVideo.removeEventListener('loadeddata', revealPip);
            pipVideo.removeEventListener('canplay', revealPip);
            pipVideo.removeEventListener('playing', revealPip);
          }

          pipVideo.addEventListener('loadeddata', revealPip);
          pipVideo.addEventListener('canplay', revealPip);
          pipVideo.addEventListener('playing', revealPip);

          pipVideo.play().then(
            function () {
              revealPip();
            },
            revealPip
          );
        });
      })
      .catch(function (err) {
      });

    window.addEventListener('resize', function () {
      if (!positionReady) setDefaultPosition();
    });
  }

  function boot() {
    document.querySelectorAll('[data-wdv-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
